import moment from "moment";
import "moment/locale/en-ca";
import "moment/locale/ru";

const _moment = moment;

const changeMomentLocale = (value: "ru-RU" | "en-EN") => {
  if (value === "ru-RU") {
    _moment.locale("ru");
  } else {
    _moment.locale("en-ca");
  }
};

let initLocale = localStorage.getItem("localization") as
  | "ru-RU"
  | "en-EN"
  | null;

initLocale = initLocale ?? "ru-RU";

changeMomentLocale(initLocale);

export { _moment, changeMomentLocale };
